import { Box, Container, Typography } from "@mui/material";
import CardContacto from "./CardContacto";
import CelularItem from "./CelularItem";
import {ScrollStatic, ScrollMove} from "../../components/common/ScrollItem";
import TextToSpeech from "../../components/TextToSpeech";

const Contacto = () => {
    const accessibilityText = `
      Comunicate al área correspondiente, procura marcar primero al numero telefonico y despues agregar la extension en pantalla.
      Los numeros a marcar son tres once docientos once noventaicuatro setenta o tambien tres once docientos catorce cero cero ochentaitres.
    `;
  return (
    <Box
      sx={{
        width: "100%",
        backgroundSize: "100% 20%",
        backgroundRepeat: "no-repeat",
        mb: { xs: "5px", sm: "10px" },
        overflow: "auto",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 15 },
          maxWidth: "100% !important",
          pl: "0 !important",
          pr: "0 !important",
        }}
      >
        <TextToSpeech text={accessibilityText} />

        <ScrollStatic>
          <Typography
            variant="h1"
            align="center"
            sx={{
              width: "100%",
              color: "#194AC1",
              p: "0 35px"
            }}
          >
            Contacto
          </Typography>
        </ScrollStatic>
      </Container>

      <ScrollMove>
        <CardContacto />
      </ScrollMove>

      <ScrollStatic>
        <CelularItem />
      </ScrollStatic>


    </Box>
  );
};

export default Contacto;
